/// <reference path="../html5controls/Controls/inforShared/js/globalize.js" />
/// <reference path="../Page/theme/basicDefinition.js" />
/// <reference path="../Page/theme/rtlDefinition.js" />
/// <reference path="../Page/Layouts/Basic.js" />
/// <reference path="../Page/Layouts/RTL.js" />
var _this = this;
// isolates the pageManager declaration
var pageManager = null;
// i guess the "instance" can change?  That's why view overwrites the frame pageManager?
function globalPageManager() {
  pageManager = PageManager();
  return pageManager;
}
var PageManager = (function() {
  var rtl = typeof Globalize == "undefined" ? false : Globalize.culture().isRTL;
  if (rtl) {
    window.themeDefinition = $.extend(
      true,
      {},
      window.basicDefinition,
      window.rtlDefinition
    );
  } else {
    window.themeDefinition = window.basicDefinition;
  }
  return function() {
    var self = _this;
    var setLayout = function(instance) {
      return (self._layout = instance);
    };
    if (rtl) {
      $("body").ipsRTLLayout({ layout: setLayout });
    } else {
      $("body").ipsBasicLayout({ layout: setLayout });
    }
    return _this._layout;
  };
})();
